import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
  title?: string | React.ReactNode | React.ReactElement | null | undefined;
  className?: string;
  children?: any;
};

const SectionPanel: FC<Props> = ({ title, className, children }) => {
  return (
    <div className={twMerge('bg-primary-3 px-5 py-8', className)}>
      {title && <div className="enki-body-base-strong text-surface-100-fg-default mb-4">{title}</div>}
      {children && <div className="p-4 rounded-300 bg-surface-100-bg">{children}</div>}
    </div>
  );
};

export default SectionPanel;
